import { render, staticRenderFns } from "./GameUIComponent.vue?vue&type=template&id=89b916ae&scoped=true"
import script from "./GameUIComponent.vue?vue&type=script&lang=js"
export * from "./GameUIComponent.vue?vue&type=script&lang=js"
import style0 from "./GameUIComponent.vue?vue&type=style&index=0&id=89b916ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b916ae",
  null
  
)

export default component.exports